/**
 * The "Level" sub-tab under /skills — XP/level hero, achievement grid, and
 * the all-time leaderboard. XP is the forward-progress axis (monotonic),
 * complementing the skill bands on the other tabs (which decay).
 */

import { useQuery } from "@tanstack/react-query";

import { getGamification } from "@/features/gamification/lib/gamification";
import { XpMeterHero } from "@/features/gamification/components/XpMeterHero";
import { AchievementGrid } from "@/features/gamification/components/AchievementGrid";
import { LeaderboardPanel } from "@/features/gamification/components/LeaderboardPanel";

export function GamificationView() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["gamification"],
    queryFn: getGamification,
    staleTime: 60_000,
  });

  if (isLoading) {
    return <p className="text-sm text-text-muted py-8 text-center">Loading…</p>;
  }
  if (isError || !data) {
    return (
      <p className="text-sm text-danger py-8 text-center">
        Couldn't load your level.
      </p>
    );
  }

  return (
    <div className="space-y-6">
      <XpMeterHero data={data} />
      <AchievementGrid achievements={data.achievements} />
      <LeaderboardPanel />
    </div>
  );
}
